const preview = document.querySelectorAll('.js-people-preview');
const close = document.querySelectorAll('.js-close-people-bio');
//Added below line for fliping arrow in Speaker section 
const toggle = document.querySelectorAll('.js-arrow-toggle');
const spaceBetweenRows = 50;

const showMorePeopleLink = document.querySelectorAll('.js-show-all-people');
const showMorePeople = document.querySelectorAll('.js-show-more-people');

function showBio() {
	preview.forEach((item) => {
		item.addEventListener('click', (e) => {
			e.preventDefault();
			let currentPreviewHeight = parseFloat(getComputedStyle(item)['height']);
			let currentBioHeight = item.nextElementSibling.offsetHeight;

			hideBio();

			item.parentElement.style.height = currentPreviewHeight + currentBioHeight + spaceBetweenRows + 'px';

			item.classList.add('is--active');
			item.nextElementSibling.classList.add('is--active');
		});
	});
	//Added below lines for fliping arrow in Speaker section - Start
	toggle.forEach((item1) => {
			item1.addEventListener('click', (e) => {
			e.preventDefault();
			// item1.style.transform = "rotate(90deg)"; 
			// item1.style.WebkitTransform = "rotate(90deg)"; 
			item1.classList.add('ion-arrow-down-b');	
			item1.classList.remove('ion-arrow-right-b');
		});
	});
	//Added above lines for fliping arrow in Speaker section - End
	
}

function hideBio() {
	for (var i = preview.length - 1; i >= 0; i--) {
	
		if (	preview[i].classList.contains('is--active')) {
				preview[i].classList.remove('is--active');
				preview[i].parentElement.removeAttribute('style');
				preview[i].nextElementSibling.classList.remove('is--active');
		}
	}
}

function hideBioOnCloseIconClick() {
	close.forEach((icon) => {
		icon.addEventListener('click', (e) => {
			e.preventDefault();
			hideBio();
			//Added below lines for fliping arrow in Speaker section - Start
			toggle.forEach((item1) => {
				item1.classList.remove('ion-arrow-down-b');	
				item1.classList.add('ion-arrow-right-b');
				//item1.style.WebkitTransform = "rotate(-90deg)";
			});
			//Added above lines for fliping arrow in Speaker section - End
		});
	});
}

function hideBioOnResize(){
	window.addEventListener('resize', () => {
		hideBio();
	});
}

function showAllPeople() {
	showMorePeopleLink.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.target.style.display = "none";
			for (var i = showMorePeople.length - 1; i >= 0; i--) {
				showMorePeople[i].classList.remove('tablet-hidden');
			}
		});
	});
}
if(preview.length > 0){
	showBio();
	hideBioOnCloseIconClick();
	hideBioOnResize();
}
showAllPeople();


// WEBPACK FOOTER //
// ../components/people/people.js